module.exports = __webpack_public_path__ + "img/test1.e82671dc.png";